<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Canje de pacientes</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>Px_canje</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos">Pacientes de un plan</b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col class="col-6">
              <b-form-group align="left">
                <label for="empresa">Empresa</label>
                <v-select
                    label="nombreComercial"
                    id="compania"
                    v-model="compania"
                    :options="lstCompania"
                    @input="seleccinarEmpresa($event)"
                    required
                >
                  <span slot="no-options">No hay datos...</span>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col class="col-6">
              <b-form-group align="left">
                <label for="plan">Planes</label>
                <v-select
                    label="nombrePlan"
                    id="plan_convenio"
                    v-model="planConvenio"
                    :options="lstPlanesConvenios"
                    required
                    :disabled="compania === null"
                    @input="buscarPacientes()"
                >
                  <span slot="no-options">No hay datos...</span>
                </v-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-input v-if="pacientes.length > 0" placeholder="Filtrar" v-model="palabraClave"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table
              id="Pacientes"
              thead-tr-class="columnas"
              :items="pacientes"
              :fields="fields"
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
              responsive="true"
              class="parrafos"
              show-empty
              :filter="palabraClave"
              :filter-function="filterTable"
              fixed
          >
            <template v-slot:cell(fechaNacimiento)="row">
              {{ row.item.fechaNacimiento | formatoFecha }}
            </template>
            <template #empty="scope">
              <div align="center" v-if="loader">
                <b-spinner variant="primary" label="Spinning"></b-spinner>
              </div>
              <div v-else>
                <b-col>
                  <b-alert v-if="planConvenio !== null && pacientes.length === 0" variant="warning" show>No hay datos
                  </b-alert>
                  <b-alert v-if="planConvenio === null" variant="warning" show>Seleccione un plan</b-alert>
                </b-col>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-if="!loader">
          <b-pagination
              v-if="pacientes !== undefined && pacientes.length > 15"
              align="center"
              v-model="paginaActual"
              :total-rows="pacientes.length"
              :per-page="registrosPorPagina"
              aria-controls="my-table1"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <download-excel
              v-if="pacientes.length > 0"
              class="btn btn-primary"
              :data="pacientesExcel"
              :fields="fieldsExcel"

              worksheet="My Worksheet"
              name="Canje de pacientes.xls"
          >
            Generar Excel
            <em class="fa fa-file-excel-o"></em>
          </download-excel>
        </b-col>
      </b-row>
      <br>
      <br>
      <br>
    </b-container>
  </div>
</template>

<script>

import Header from "@/components/Header";

export default {
  name: "canje",
  components: {Header},
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      loader: false,
      loaderAcciones: false,
      ids: [],
      pacientes: [],
      pacientesExcel: [],
      fields: [
        {key: "idPaciente", label: "ID", sortable: true},
        {key: "nombrePaciente", label: "Nombre del paciente", sortable: true},
        {key: "fechaNacimiento", label: "Fecha de Nacimeinto", sortable: true},
      ],
      fieldsExcel: { "ID":"idPaciente","Nombre del paciente":"nombrePaciente", "Fecha de Nacimeinto":"fechaNacimiento"},
      compania: null,
      planConvenio: null,
      lstCompania: [],
      lstPlanesConvenios: [],
      loaderPlan: false,
      registrosPorPagina: 15,
      paginaActual: 0,
      palabraClave: null,
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerListaEmpresas();
  },
  methods: {
    obtenerListaEmpresas() {
      this.$http
          .get(this.$api + "empresas/obtener")
          .then((response) => {
            if (response.data.data) {
              let resultado = response.data.data;
              this.lstCompania = [];
              resultado.forEach((item, index) => {
                item.id = index;
                this.lstCompania.push(item);
              });
            }
          })
          .catch(function (error) {
            console.error(error);
            this.$swal({
              icon: "error",
              text: "A ocurrido un error, intentalo más tarde.",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          });
    },
    seleccinarEmpresa(evento) {
      this.lstPlanesConvenios = [];
      this.planConvenio = null;
      this.loaderPlan = false;
      this.obtenerPlanesEmpresa(evento);
    },
    obtenerPlanesEmpresa(empresa) {
      this.planConvenio = null;
      const parametros = {idEmpresa: empresa.idEmpresa}
      var url = "empresas/obtener/planes";

      this.$http
          .post(
              this.$api + url, parametros
          )
          .then((response) => {
            if (response.data.data) {
              let resultado = response.data.data;
              this.lstPlanesConvenios = [];
              resultado.forEach((item, index) => {
                item.id = index;
                this.lstPlanesConvenios.push(item);
              });
            }
          })
          .catch(function (error) {
            console.error(error);
            this.$swal({
              icon: "error",
              text: "A ocurrido un error, intentalo más tarde.",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          })
          .finally(() => {
            this.loaderPlan = true;
          });
    },
    buscarPacientes() {
      this.loader = true;
      this.pacientes = [];
      const parametros = {idPlan: this.planConvenio.idPlan}
      this.$http.post(this.$api + "planConvenio/canje", parametros).then((respuesta) => {
        if (respuesta.data.data) {
          this.pacientes = respuesta.data.data;

          this.pacientesExcel = JSON.parse(JSON.stringify(respuesta.data.data));

          this.pacientesExcel.map(value => {
            value.fechaNacimiento =  this.$formatoFecha(value.fechaNacimiento)
          })


        }
      }).catch(reason => {
        console.error(reason);
        this.$swal({
          icon: "error",
          text: "A ocurrido un error al obtener la información.",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
      }).finally(() => {
        this.loader = false;
      });
    },
    filterTable(row, filter) {
      return parseInt(row.idPaciente) === parseInt(filter)
          || row.nombrePaciente.toLowerCase().search(filter.toLowerCase()) !== -1
          || this.$options.filters.formatoFecha(row.fechaNacimiento).toLowerCase().search(filter.toLowerCase()) !== -1

    }
  }
}
</script>

<style scoped>

</style>